export interface AppConfig {
  brand_name: string;
  logo_url: string | null;
  theme: {
    primary_color: string;
    secondary_color: string;
    font_family: string;
  };
  features: Record<string, { enabled: boolean }>;
  analytics: {
    posthog: {
      public_api_key: string;
    };
  };
  rum: {
    application_id: string;
    region: string;
  };
}

const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

export async function loadConfig(): Promise<AppConfig> {
  const response = await fetch(`${API_BASE}/api/config`);
  if (!response.ok) {
    throw new Error(`Failed to load config: ${response.status}`);
  }
  return response.json();
}

export async function loadFeatures(): Promise<AppConfig["features"]> {
  const token = sessionStorage.getItem("notetaker_token");
  const response = await fetch(`${API_BASE}/api/features`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    throw new Error(`Failed to load features: ${response.status}`);
  }
  return response.json();
}

export function applyTheme(config: AppConfig): void {
  const root = document.documentElement;
  root.style.setProperty("--primary-color", config.theme.primary_color);
  root.style.setProperty("--secondary-color", config.theme.secondary_color);
  root.style.setProperty("--font-family", config.theme.font_family);
}
